import type { ViewScopeQueryKeys } from "@web/features/Views/defaultViewQuery";

/** Query param for user group scope (will become `taskList` in a later epic). */
export const TASK_VIEW_USER_GROUP_QUERY_KEY = "userGroup";

export const TASK_VIEW_SCOPE_QUERY = {
  propertyRoute: "propertyRoute",
  userGroup: TASK_VIEW_USER_GROUP_QUERY_KEY,
  user: "user",
  property: "property",
  propertyBrowse: "propertyBrowse",
} as const;

export type TaskViewScopeQueryKey = keyof typeof TASK_VIEW_SCOPE_QUERY;

/** The query parameter of each task view scope type (`ViewScopeTypeEnum` in the API). */
export const TASK_VIEW_SCOPE_QUERY_BY_TYPE = {
  propertyRoute: TASK_VIEW_SCOPE_QUERY.propertyRoute,
  taskList: TASK_VIEW_SCOPE_QUERY.userGroup,
  property: TASK_VIEW_SCOPE_QUERY.property,
  user: TASK_VIEW_SCOPE_QUERY.user,
} as const satisfies ViewScopeQueryKeys;

export interface TaskViewScopeParams {
  propertyRoute: string | null
  userGroup: string | null
  user: string | null
  property: string | null
}

export function parseTaskViewScopeFromQuery(query: Record<string, unknown>): TaskViewScopeParams {
  function one(key: string): string | null {
    const raw = query[key];
    const value = Array.isArray(raw) ? raw[0] : raw;
    return typeof value === "string" && value !== "" ? value : null;
  }

  return {
    propertyRoute: one(TASK_VIEW_SCOPE_QUERY.propertyRoute),
    userGroup: one(TASK_VIEW_SCOPE_QUERY.userGroup),
    user: one(TASK_VIEW_SCOPE_QUERY.user),
    property: one(TASK_VIEW_SCOPE_QUERY.property),
  };
}

/** A per-object link or an object's list: the sidebar opens its "Per object" section for it. */
export function isPropertyBrowseQuery(query: Record<string, unknown>): boolean {
  const raw = query[TASK_VIEW_SCOPE_QUERY.propertyBrowse];
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (value === "1" || value === "true") {
    return true;
  }
  return parseTaskViewScopeFromQuery(query).property != null;
}
